import ProductType from './enum/ProductType';

const PRODUCT_TYPE_ENUM_LABEL: Record<ProductType, string> = {
  [ProductType.TIME]: 'Time',
  [ProductType.TIME_AND_NUMBER]: 'Time and number',
  [ProductType.NUMBER_LIMIT]: 'Number',
};

export default PRODUCT_TYPE_ENUM_LABEL;
